import { PlacementSource, SmartConfigMode } from '@zg-rentals/ts-rental-manager-api-client';

export type BulkSpotlightTarget = 'PINNED' | 'SMART_ASSIGN' | 'EXCLUDED';

export type BulkSpotlightMutation = 'exclude' | 'include' | 'pin' | 'unexclude' | 'uninclude';

export type BulkSpotlightTransitionPlan = {
  alreadyAtTargetCount: number;
  aliasesByMutation: Record<BulkSpotlightMutation, Array<string>>;
  managedByFeedSkippedCount: number;
  netNewPinSlots: number;
  unknownSourceCount: number;
};

export type BulkSpotlightListing = {
  listingAlias: string;
  managedByFeed?: boolean;
  placementSource: PlacementSource | null | undefined;
};

const createEmptyMutationGroups = (): Record<BulkSpotlightMutation, Array<string>> => ({
  exclude: [],
  include: [],
  pin: [],
  unexclude: [],
  uninclude: [],
});

export const planBulkSpotlightTransitions = (
  smartConfigMode: SmartConfigMode,
  target: BulkSpotlightTarget,
  listings: Array<BulkSpotlightListing>,
): BulkSpotlightTransitionPlan => {
  const aliasesByMutation = createEmptyMutationGroups();
  let alreadyAtTargetCount = 0;
  let managedByFeedSkippedCount = 0;
  let netNewPinSlots = 0;
  let unknownSourceCount = 0;

  listings.forEach(({ listingAlias, managedByFeed, placementSource }) => {
    if (placementSource === undefined) {
      unknownSourceCount += 1;
      return;
    }
    const source = placementSource;

    if (target === 'PINNED') {
      if (source === PlacementSource.PINNED) {
        alreadyAtTargetCount += 1;
        return;
      }
      if (managedByFeed) {
        managedByFeedSkippedCount += 1;
        return;
      }
      aliasesByMutation.pin.push(listingAlias);
      if (source !== PlacementSource.AUTO) {
        netNewPinSlots += 1;
      }
      return;
    }

    if (target === 'SMART_ASSIGN') {
      if (smartConfigMode === SmartConfigMode.ALL_INCLUDED) {
        if (source === PlacementSource.PINNED) {
          aliasesByMutation.uninclude.push(listingAlias);
        } else if (source === PlacementSource.EXCLUDED) {
          aliasesByMutation.unexclude.push(listingAlias);
        } else {
          alreadyAtTargetCount += 1;
        }
        return;
      }
      if (source === PlacementSource.AUTO || source === PlacementSource.INCLUDED) {
        alreadyAtTargetCount += 1;
      } else {
        aliasesByMutation.include.push(listingAlias);
      }
      return;
    }

    if (smartConfigMode === SmartConfigMode.ALL_INCLUDED) {
      if (source === PlacementSource.EXCLUDED) {
        alreadyAtTargetCount += 1;
      } else {
        aliasesByMutation.exclude.push(listingAlias);
      }
      return;
    }
    if (source === PlacementSource.AUTO || source === PlacementSource.INCLUDED || source === PlacementSource.PINNED) {
      aliasesByMutation.uninclude.push(listingAlias);
    } else {
      alreadyAtTargetCount += 1;
    }
  });

  return {
    alreadyAtTargetCount,
    aliasesByMutation,
    managedByFeedSkippedCount,
    netNewPinSlots,
    unknownSourceCount,
  };
};
